/* unplugin-vue-components disabled */import { render } from "./gyqx.vue?vue&type=template&id=349556ae&scoped=true"
import script from "./gyqx.vue?vue&type=script&lang=js"
export * from "./gyqx.vue?vue&type=script&lang=js"

import "./gyqx.vue?vue&type=style&index=0&id=349556ae&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349556ae"]])

export default __exports__